<template>
  <div class="e-my" v-if="$store.state.userInfo">
    <div class="e-my-top">
      <div class="bg-filter" :style="{backgroundImage: `url(${$store.state.userInfo.headerimg})`}"></div>
      <div class="e-my-info">
        <img :src="$store.state.userInfo.headerimg" alt="">
        <p>{{ $store.state.userInfo.truename }}</p>
      </div>
    </div>
    <ul class="e-my-list">
      <li @click="$router.push('/m/myclass')">
        <i class="iconfont icon-jiaoshi classroom"></i>
        我的教室
      </li>
      <li @click="$router.push('/m/mycert')">
        <i class="iconfont icon-zhengshu certificate"></i>
        我的证书
      </li>
      <!-- <li>
        <i class="iconfont icon-zhengque config"></i>
        个人设置
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  mounted () {
    setTimeout(()=>{
      if (!this.$store.state.userInfo) {
        window.location.href = "https://www.aiimooc.com/mobile/login.php?forward=" + window.location.href
      }
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.e-my{
  width: 100%;
  padding-bottom: 50px;
  .e-my-top{
    height: 180px;
    position: relative;
    .bg-filter{
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      filter: blur(15px);
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    .e-my-info{
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 79px);
      z-index: 10;
      border-radius: 50%;
      img{
        border-radius: 50%;
        width: 100px;
        height: 100px;
      }
      p{
        margin-top: 8px;
        line-height: 21px;
        font-size: 16px;
        text-align: center;
      }
    }
  }
  .e-my-list{
    margin-top: 105px;
    padding: 30px;
    li{
      line-height: 55px;
      font-size: 15px;
      color: #5D6064;
      padding-left: 30px;
      border-bottom: 1px solid #EBEBEB;
      position: relative;
      .iconfont{
        position: absolute;
        line-height: 55px;
        top: 0;
        left: 4px;
        font-size: 20px;
      }
      .classroom{
        color: #F8415B;
      }
      .certificate{
        color: #21E1C0;
      }
      .config{
        color: #4491F5;
      }
    }
  }
}
</style>
